import React, { createContext, useContext, useMemo, useCallback, ReactNode } from 'react'

// Create a mock context that matches what @react-keycloak/web provides
const KeycloakContext = createContext<any>(null)

// Simple mock that matches what useKeycloak returns
interface KeycloakContextValue {
  keycloak: {
    authenticated: boolean
    token?: string
    tokenParsed?: Record<string, unknown>
    login: () => void
    logout: () => void
    updateToken: (minValidity?: number) => Promise<boolean>
  }
  initialized: boolean
}

interface MockKeycloakProviderProps {
  children: ReactNode
  authenticated?: boolean
  token?: string
  tokenParsed?: Record<string, unknown>
}

export const MockKeycloakProvider: React.FC<MockKeycloakProviderProps> = ({
  children,
  authenticated = false,
  token,
  tokenParsed,
}) => {
  const login = useCallback(() => {}, [])
  const logout = useCallback(() => {}, [])
  const updateToken = useCallback(() => Promise.resolve(false), [])

  const mockValue = useMemo<KeycloakContextValue>(() => ({
    keycloak: {
      authenticated,
      token,
      tokenParsed,
      login,
      logout,
      updateToken,
    },
    initialized: true,
  }), [authenticated, token, tokenParsed, login, logout, updateToken])

  return (
    <KeycloakContext.Provider value={mockValue}>
      {children}
    </KeycloakContext.Provider>
  )
}

// Export a hook that can be used instead of useKeycloak when mocking
export const useMockKeycloak = () => {
  const context = useContext(KeycloakContext)
  if (!context) {
    throw new Error('useMockKeycloak must be used within MockKeycloakProvider')
  }
  return context
}
